import {
    HorizAlignment,
    IProfileFilter,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    ISearchSort,
    ITree,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import * as _ from "lodash";
import { PASearch } from "../PA.Core/PASearch";
import { CustomerSearch } from "../PA.UIM.MD/CustomerSearch";
import { PlanningLevelSearch } from "./PlanningLevelSearch";
import { SearchUtils } from "../PA.UIM.Core/SearchUtils";
import { ColumnNodeProvider } from "../PA.UIM.Core/SearchTreeUtils";
import { PAEnvironment } from "../PA.Core/PAEnvironment";

const PlanSearch: ISearch = {
    searchName: "Find Plan",
    renderOptions: { ui5ResourceId: "PlanSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: []
};

const vUI_Plan_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_PLAN_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "WB Plan Id",
            columnResourceName: "colId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    PLAN_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Plan Id",
            columnResourceName: "colId",
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 50
        }
    },
    PLAN_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Plan Name",
            columnResourceName: "colName",
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 256
        }
    },

    WB_CUST_ID_PLANNING: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Planning Cust WB Id",
            columnResourceName: "colPlnCstId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {
            search: CustomerSearch,
            profileId: "MyPlanningCustomers",
            searchCondition: {}
        }
    },
    PLANNING_CUSTOMER_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Planning Customer",
            columnResourceName: "colPlnCst",
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 256
        }
    },
    BUSINESSUNIT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Business Unit Name",
            columnResourceName: "colBusinessUnit",
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            bUseSearchProvidersDistinctValues: true,
            maxLength: 256
        }
    },
    WB_BUSINESSUNIT_ID: {
        type: SearchProviderFieldType.number
    },
    WB_CUST_ID_SUBPLANNING: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Sub Planning Cust WB Id",
            columnResourceName: "colPlnCstId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    SUBPLANNING_CUSTOMER_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Sub Planning Customer",
            columnResourceName: "colPlnCst",
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 256
        }
    },
    PLANNING_LEVEL_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Planning Level ID",
            columnResourceName: "colLevelID",
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 50,
            search: PlanningLevelSearch,
            profileId: "",
            searchCondition: {}
        }
    },
    PLANNING_LEVEL_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Planning Level",
            columnResourceName: "colLevelName",
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 256
        }
    },
    WORKFLOW_STATUS_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Status Id",
            columnResourceName: "colWorkflowStatusId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    RETAILER_FORMAT_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Retailer Format Id",
            columnResourceName: "colRetailerFormatId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    SALESORG: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Sales Org",
            columnResourceName: "colSalesOrg",
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 20
        }
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Sales Org",
            columnResourceName: "colPlanSalesOrg",
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: PlanSearch,
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 256
        }
    },
    INSTORE_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "InStore Start Dt",
            columnResourceName: "colInStoreStart",
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    INSTORE_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "InStore End Dt",
            columnResourceName: "colInStoreEnd",
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    SHIPMENT_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "Shipment Start Dt",
            columnResourceName: "colShipmentStart",
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    SHIPMENT_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "Shipment End Dt",
            columnResourceName: "colShipmentEnd",
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    SOURCE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Source ID",
            columnResourceName: "colSourceId",
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 50,
            source: true,
            useIdAsKey: true
        }
    },
    EVENT_COUNT: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Event Count",
            columnResourceName: "colEventCount",
            alignment: HorizAlignment.Right,
            numberFormat: "#,##0"
        },
        domainOptions: {}
    },
    SPEND_PLANNED: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Planned Spend",
            columnResourceName: "colPlannedSpend",
            alignment: HorizAlignment.Right,
            numberFormat: "#,##0.00"
        },
        domainOptions: {}
    },
    SPEND_ACTUAL: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "TPM Actual Spend",
            columnResourceName: "colActualSpend",
            alignment: HorizAlignment.Right,
            numberFormat: "#,##0.00"
        },
        domainOptions: {}
    },
    SPEND_PA_LE: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "PA LE Spend",
            columnResourceName: "colTPMLESpend",
            alignment: HorizAlignment.Right,
            numberFormat: "#,##0.00"
        },
        domainOptions: {}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Sales Org WB Id",
            columnResourceName: "colSalesOrgId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "Created Date",
            columnResourceName: "colCreateDt",
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "Modified Date",
            columnResourceName: "colModifiedDt",
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const vUI_Plan_Search_By_Event_Fields: { [id: string]: ISearchProviderField } = {};

_.defaults(vUI_Plan_Search_By_Event_Fields, vUI_Plan_Search_Fields);
_.defaults(vUI_Plan_Search_By_Event_Fields, {
    WB_EVT_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: "WB Event Id", columnResourceName: "colEvtId", alignment: HorizAlignment.Center },
        domainOptions: {}
    },
    EVENT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Event Id", columnResourceName: "colEvtId", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    EVENT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Event Name", columnResourceName: "colEvtName", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },

    EVENT_TYPE_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Event Type Id",
            columnResourceName: "colEvtTypeId",
            alignment: HorizAlignment.Center
        },
        domainOptions: { metaTypeIds: ["Event Type"] }
    },
    EVENT_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Event Type Name",
            columnResourceName: "colEvtTypeName",
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            profileId: "byEvent",
            bUseSearchProvidersDistinctValues: true
        }
    },

    EVENT_WORKFLOW_STATUS_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Event Status Id",
            columnResourceName: "colEvtStatusId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    WORKFLOW_STATUS_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Event Status Name",
            columnResourceName: "colEvtStatusName",
            alignment: HorizAlignment.Left
        },
        domainOptions: { profileId: "byEvent", bUseSearchProvidersDistinctValues: true }
    },

    EVENT_INSTORE_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "Event InStore Start Dt",
            columnResourceName: "colEvtInStoreStart",
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    EVENT_INSTORE_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "Event InStore End Dt",
            columnResourceName: "colEvtInStoreEnd",
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },

    EVENT_SOURCE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Event Source ID",
            columnResourceName: "colEvtSourceId",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50, source: true, useIdAsKey: true }
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Sales Org", columnResourceName: "colSalesOrg", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 20 }
    }
});

const PlanSearchProviderBasic: ISearchProvider = {
    keyFields: {
        id: "WB_PLAN_ID",
        id_ui: "PLAN_ID",
        name: "PLAN_NAME",
        source_id: "SOURCE_ID"
    },

    searchProviderFields: vUI_Plan_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            const self = this;
            const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);
            searchRequestSubset.where["WB_SALESORG_ID"] = { inq: _.map(usrContext.WB_SalesOrgs, "WB_SALESORG_ID") };

            const findRequest = SearchUtils.makeSearchRequest(
                searchRequestSubset,
                "vUI_Plan_Search",
                self.searchProviderFields,
                []
            );
            if (_.isEmpty(findRequest.order)) {
                findRequest.order = ["PLANNING_CUSTOMER_NAME", "PLANNING_LEVEL_NAME"];
            }

            async function getPlans() {
                const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);
                if (!usrContext.hasRoleId("VIEW_ALL")) {
                    await SearchUtils.addUserGroupPlansFilter(findRequest, "WB_PLAN_ID");
                }

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        _.forEach(res, (aRes: any) => {
                            aRes.SPEND_PLANNED = Number(aRes.SPEND_PLANNED);
                            aRes.SPEND_ACTUAL = Number(aRes.SPEND_ACTUAL);
                            aRes.SPEND_PA_LE = Number(aRes.SPEND_PA_LE);
                        });

                        resolve(res);
                    })
                    .catch((err) => {
                        error(err);
                    });
            }

            getPlans();
        });
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);
            const salesorgs = _.map(usrContext.WB_SalesOrgs, "SALESORG_NAME");

            const findRequest = SearchUtils.makeSearchRequest(
                { where: { SALESORG_NAME: { inq: salesorgs } } },
                "vUI_Plan_Search",
                this.searchProviderFields,
                [fieldName]
            );

            async function getPlans() {
                const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);
                if (!usrContext.hasRoleId("VIEW_ALL")) {
                    await SearchUtils.addUserGroupPlansFilter(findRequest, "WB_PLAN_ID");
                }

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(
                            _.map(res, (aRow) => {
                                return aRow[fieldName];
                            })
                        );
                    })
                    .catch((err) => {
                        error(err);
                    });
            }

            getPlans();
        });
    }
};

const PlanSearchProviderByEvent: ISearchProvider = {
    keyFields: {
        id: "WB_PLAN_ID",
        id_ui: "EVENT_ID",
        name: "EVENT_NAME",
        source_id: "SOURCE_ID"
    },

    searchProviderFields: vUI_Plan_Search_By_Event_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);
            searchRequestSubset.where["SALESORG"] = { inq: _.map(usrContext.WB_SalesOrgs, "SALESORG_ID") };

            const findRequest = SearchUtils.makeSearchRequest(
                searchRequestSubset,
                "vUI_Plan_Search_By_Event",
                this.searchProviderFields,
                []
            );
            if (_.isEmpty(findRequest.order)) {
                findRequest.order = ["PLANNING_CUSTOMER_NAME", "PLANNING_LEVEL_NAME", "EVENT_NAME"];
            }
            if (!usrContext.hasRoleId("VIEW_ALL"))
                SearchUtils.addUsrContextCustomerFilter(findRequest, "WB_CUST_ID_PLANNING");

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res);
                })
                .catch((err) => {
                    error(err);
                });
        });
    },

    // Filter with drop down in the TPM Event Search
    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);
            const salesorgs = _.map(usrContext.WB_SalesOrgs, "WB_SALESORG_ID");
            const findRequest = SearchUtils.makeSearchRequest(
                { where: { WB_SALESORG_ID: { inq: salesorgs } } },
                "vUI_Plan_Search_By_Event",
                this.searchProviderFields,
                [fieldName]
            );
            if (!usrContext.hasRoleId("VIEW_ALL"))
                SearchUtils.addUsrContextCustomerFilter(findRequest, "WB_CUST_ID_PLANNING");
            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(
                        _.map(res, (aRow) => {
                            return aRow[fieldName];
                        })
                    );
                })
                .catch((err) => {
                    error(err);
                });
        });
    }
};

const PlanSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Customer, Planning Level, Plan Name",
    renderOptions: { ui5ResourceId: "PlanSearchProfileByName" },

    profileFilter: [
        {
            profileFilterName: "Customer",
            searchProviderFieldId: "WB_CUST_ID_PLANNING",
            bMultiSelect: true,
            renderOptions: {}
        },
        {
            profileFilterName: "Planning Level",
            searchProviderFieldId: "PLANNING_LEVEL_ID",
            bMultiSelect: true,
            renderOptions: {}
        },
        { profileFilterName: "Plan Name", searchProviderFieldId: "PLAN_NAME", renderOptions: {} },
        {
            profileFilterName: "Customer Name",
            searchProviderFieldId: "PLANNING_CUSTOMER_NAME",
            renderOptions: {},
            bQuickSearch: true,
            bHidden: true
        },
        {
            profileFilterName: "Sales Org",
            searchProviderFieldId: "SALESORG_NAME",
            bMultiSelect: true,
            renderOptions: {}
        }
    ], // ISearchFields
    profileDisplayFields: [
        "PLAN_NAME",
        "PLANNING_LEVEL_NAME",
        "SALESORG_NAME",
        {
            columnTitle: "InStore Dates",
            fields: ["INSTORE_START_DT", "INSTORE_END_DT"],
            seperator: " - ",
            alignment: HorizAlignment.Center
        },
        // {columnTitle: "Shipments Dates", fields: ['SHIPMENT_START_DT','SHIPMENT_END_DT'], seperator: " - ",alignment: HorizAlignment.Center },
        "EVENT_COUNT",
        "SPEND_PLANNED",
        "SPEND_ACTUAL",
        "SPEND_PA_LE",
        "CREATED_DTTS",
        "MODIFIED_DTTS",
        {
            columnTitle: "Lock",
            lockClass: "Plan",
            lockIdFieldName: "WB_PLAN_ID",
            bDisplayLockIcon: true,
            bDisplayLockOwner: true
        }
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PlanSearchProviderBasic,

    profileTreeIdDefault: "ByPlanningCustomer",
    profileTrees: [
        {
            treeId: "ByPlanningCustomer",
            treeName: "By Planning Customer",
            nodeProviders: [
                new ColumnNodeProvider(["PLANNING_CUSTOMER_NAME"], { defaultValues: "Empty Planning Customer" })
            ],
            renderOptions: {}
        },
        {
            treeId: "ByPlanningLevel",
            treeName: "By Planning Level",
            nodeProviders: [new ColumnNodeProvider(["PLANNING_LEVEL_NAME"], { defaultValues: "Empty Planning Level" })],
            renderOptions: {}
        },
        {
            treeId: "ByPlanningCustomerLevel",
            treeName: "By Planning Customer/ Level",
            nodeProviders: [
                new ColumnNodeProvider(["PLANNING_CUSTOMER_NAME", "PLANNING_LEVEL_NAME"], {
                    defaultValues: ["Not Set", "Not Set"]
                })
            ],
            renderOptions: {}
        }
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "", //string;
    profileSorts: [] //ISearchSort[];
};

const PlanSearchProfileNoLock: ISearchProfile = {
    profileId: "NoLock",
    profileName: "Customer, Planning Level, Plan Name",
    renderOptions: { ui5ResourceId: "PlanSearchProfileNoLock" },

    profileFilter: [
        {
            profileFilterName: "Customer",
            searchProviderFieldId: "WB_CUST_ID_PLANNING",
            bMultiSelect: true,
            renderOptions: {}
        },
        {
            profileFilterName: "Planning Level",
            searchProviderFieldId: "PLANNING_LEVEL_ID",
            bMultiSelect: true,
            renderOptions: {}
        },
        { profileFilterName: "Plan Name", searchProviderFieldId: "PLAN_NAME", renderOptions: {} },
        {
            profileFilterName: "Customer Name",
            searchProviderFieldId: "PLANNING_CUSTOMER_NAME",
            renderOptions: {},
            bQuickSearch: true,
            bHidden: true
        },
        {
            profileFilterName: "Sales Org",
            searchProviderFieldId: "SALESORG_NAME",
            bMultiSelect: true,
            renderOptions: {}
        }
    ], // ISearchFields
    profileDisplayFields: [
        "PLAN_NAME",
        "PLANNING_LEVEL_NAME",
        "SALESORG_NAME",
        {
            columnTitle: "InStore Dates",
            fields: ["INSTORE_START_DT", "INSTORE_END_DT"],
            seperator: " - ",
            alignment: HorizAlignment.Center
        },
        // {columnTitle: "Shipments Dates", fields: ['SHIPMENT_START_DT','SHIPMENT_END_DT'], seperator: " - ",alignment: HorizAlignment.Center },
        "EVENT_COUNT",
        "SPEND_PLANNED",
        "SPEND_ACTUAL",
        "SPEND_PA_LE",
        "CREATED_DTTS",
        "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PlanSearchProviderBasic,

    profileTreeIdDefault: "ByPlanningCustomer",
    profileTrees: [
        {
            treeId: "ByPlanningCustomer",
            treeName: "By Planning Customer",
            nodeProviders: [
                new ColumnNodeProvider(["PLANNING_CUSTOMER_NAME"], { defaultValues: "Empty Planning Customer" })
            ],
            renderOptions: {}
        },
        {
            treeId: "ByPlanningLevel",
            treeName: "By Planning Level",
            nodeProviders: [new ColumnNodeProvider(["PLANNING_LEVEL_NAME"], { defaultValues: "Empty Planning Level" })],
            renderOptions: {}
        },
        {
            treeId: "ByPlanningCustomerLevel",
            treeName: "By Planning Customer/ Level",
            nodeProviders: [
                new ColumnNodeProvider(["PLANNING_CUSTOMER_NAME", "PLANNING_LEVEL_NAME"], {
                    defaultValues: ["Not Set", "Not Set"]
                })
            ],
            renderOptions: {}
        }
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "", //string;
    profileSorts: [] //ISearchSort[];
};


const PlanSearchProfileByEvent: ISearchProfile = {
    profileId: "byEvent",
    profileName: "Event",
    renderOptions: { ui5ResourceId: "PlanSearchProfileByEvent" },

    profileFilter: [
        {
            profileFilterName: "Customer",
            searchProviderFieldId: "WB_CUST_ID_PLANNING",
            bMultiSelect: true,
            renderOptions: {}
        },
        {
            profileFilterName: "Planning Level",
            searchProviderFieldId: "PLANNING_LEVEL_ID",
            bMultiSelect: true,
            renderOptions: {}
        },
        { profileFilterName: "Event Id", searchProviderFieldId: "EVENT_ID", renderOptions: {} },
        { profileFilterName: "Event Name", searchProviderFieldId: "EVENT_NAME", renderOptions: {} },
        {
            profileFilterName: "Event Type",
            searchProviderFieldId: "EVENT_TYPE_NAME",
            bMultiSelect: true,
            renderOptions: {}
        },
        {
            profileFilterName: "Event Status",
            searchProviderFieldId: "WORKFLOW_STATUS_NAME",
            bMultiSelect: true,
            renderOptions: {}
        }
    ], // ISearchFields
    profileDisplayFields: [
        "EVENT_ID",
        "EVENT_NAME",
        "EVENT_TYPE_NAME",
        "WORKFLOW_STATUS_NAME",
        {
            columnTitle: "InStore Dates",
            fields: ["EVENT_INSTORE_START_DT", "EVENT_INSTORE_END_DT"],
            seperator: " - ",
            alignment: HorizAlignment.Center
        },
        "PLAN_NAME",
        "PLANNING_LEVEL_NAME",
        {
            columnTitle: "Lock",
            lockClass: "Plan",
            lockIdFieldName: "WB_PLAN_ID",
            bDisplayLockIcon: true,
            bDisplayLockOwner: true
        }
        // {columnTitle: "Shipments Dates", fields: ['SHIPMENT_START_DT','SHIPMENT_END_DT'], seperator: " - ",alignment: HorizAlignment.Center },
        //'EVENT_COUNT','SPEND_PLANNED','SPEND_ACTUAL','SPEND_TPM_LE'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PlanSearchProviderByEvent,

    profileTreeIdDefault: "ByPlanningCustomer",
    profileTrees: [
        {
            treeId: "ByPlanningCustomerEvt",
            treeName: "By Planning Customer",
            nodeProviders: [
                new ColumnNodeProvider(["PLANNING_CUSTOMER_NAME", "PLAN_NAME"], {
                    defaultValues: ["Empty Planning Customer", "Empty Plan Name"]
                })
            ],
            renderOptions: {}
        },
        {
            treeId: "ByPlanningLevelEvt",
            treeName: "By Planning Level",
            nodeProviders: [
                new ColumnNodeProvider(["PLANNING_LEVEL_NAME", "PLAN_NAME"], {
                    defaultValues: ["Empty Planning Level", "Empty Plan Name"]
                })
            ],
            renderOptions: {}
        },
        {
            treeId: "ByPlanningCustomerLevelEvt",
            treeName: "By Planning Customer/ Level",
            nodeProviders: [
                new ColumnNodeProvider(["PLANNING_CUSTOMER_NAME", "PLANNING_LEVEL_NAME", "PLAN_NAME"], {
                    defaultValues: ["Not Set", "Not Set", "Not Set"]
                })
            ],
            renderOptions: {}
        }
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "", //string;
    profileSorts: [] //ISearchSort[];
};

PlanSearch.searchProfiles = [PlanSearchProfileByName, PlanSearchProfileByEvent, PlanSearchProfileNoLock];
PAEnvironment.registerBusinessObjectSearch("PlanBO", "Plan", PlanSearch, "Plan Search");

export { PlanSearch };

class PlanSearchProviderBasicBySalesOrg implements ISearchProvider {
    profile: ISearchProfile;
    wbSalesOrgId: number;

    constructor(wbSalesOrgId: number, profile: ISearchProfile) {
        this.wbSalesOrgId = wbSalesOrgId;
        this.profile = profile;
    }

    keyFields = {
        id: "WB_PLAN_ID",
        id_ui: "PLAN_ID",
        name: "PLAN_NAME",
        source_id: "SOURCE_ID"
    };

    searchProviderFields = vUI_Plan_Search_Fields;

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            const self = this;

            const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);
            if (this.wbSalesOrgId > 0)
                searchRequestSubset.where["WB_SALESORG_ID"] = {
                    inq: _.intersection([this.wbSalesOrgId], _.map(usrContext.WB_SalesOrgs, "WB_SALESORG_ID"))
                };
            else
                searchRequestSubset.where["WB_SALESORG_ID"] = { inq: _.map(usrContext.WB_SalesOrgs, "WB_SALESORG_ID") };

            const findRequest = SearchUtils.makeSearchRequest(
                searchRequestSubset,
                "vUI_Plan_Search",
                self.searchProviderFields,
                []
            );
            if (_.isEmpty(findRequest.order)) {
                findRequest.order = ["PLANNING_CUSTOMER_NAME", "PLANNING_LEVEL_NAME"];
            }

            async function getPlans() {
                const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);
                if (!usrContext.hasRoleId("VIEW_ALL")) {
                    await SearchUtils.addUserGroupPlansFilter(findRequest, "WB_PLAN_ID");
                }

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        _.forEach(res, (aRes: any) => {
                            aRes.SPEND_PLANNED = Number(aRes.SPEND_PLANNED);
                            aRes.SPEND_ACTUAL = Number(aRes.SPEND_ACTUAL);
                            aRes.SPEND_PA_LE = Number(aRes.SPEND_PA_LE);
                        });

                        resolve(res);
                    })
                    .catch((err) => {
                        error(err);
                    });
            }

            getPlans();
        });
    }

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);
            let salesorgs = _.map(usrContext.WB_SalesOrgs, "SALESORG_NAME");
            if (this.wbSalesOrgId > 0)
                salesorgs = _.intersection([this.wbSalesOrgId], _.map(usrContext.WB_SalesOrgs, "WB_SALESORG_ID"));

            const findRequest = SearchUtils.makeSearchRequest(
                { where: { SALESORG_NAME: { inq: salesorgs } } },
                "vUI_Plan_Search",
                this.searchProviderFields,
                [fieldName]
            );

            async function getPlans() {
                const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext);
                if (!usrContext.hasRoleId("VIEW_ALL")) {
                    await SearchUtils.addUserGroupPlansFilter(findRequest, "WB_PLAN_ID");
                }

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(
                            _.map(res, (aRow) => {
                                return aRow[fieldName];
                            })
                        );
                    })
                    .catch((err) => {
                        error(err);
                    });
            }

            getPlans();
        });
    }
}

class PlanSearchProfile implements ISearchProfile {
    aSearchProvider: ISearchProvider = undefined;
    wbSalesOrgId: number = undefined;

    profileId = "default";
    profileName = "Search By Customer, Plan Name";
    renderOptions = { ui5ResourceId: "PlanSearchProfile" };

    profileFilter: IProfileFilter[] = [
        { profileFilterName: "Plan Id", searchProviderFieldId: "PLAN_ID", renderOptions: {}, bQuickSearch: true },
        { profileFilterName: "Plan Name", searchProviderFieldId: "PLAN_NAME", renderOptions: {}, bQuickSearch: true }
    ];

    profileDisplayFields = [
        "PLANNING_CUSTOMER_NAME",
        "PLANNING_LEVEL_NAME",
        "PLAN_NAME",
        "PLAN_ID",
        "SOURCE_ID",
        {
            columnTitle: "InStore Dates",
            fields: ["INSTORE_START_DT", "INSTORE_END_DT"],
            seperator: " - ",
            alignment: HorizAlignment.Center
        }
    ];

    profileTreeIdDefault = "default";
    profileTrees: ITree[] = [];

    profileSortIdDefault = ""; //string;
    profileSorts: ISearchSort[] = []; //ISearchSort[];

    constructor(options: any) {
        if (!_.isEmpty(options) && "WB_SALESORG_ID" in options) this.wbSalesOrgId = options.WB_SALESORG_ID;

        this.aSearchProvider = new PlanSearchProviderBasicBySalesOrg(this.wbSalesOrgId, this);
    }

    get profileSearchProvider() {
        return this.aSearchProvider;
    }
}

export class PlanSearchNoLock implements ISearch {
    constructor(options?: any) {
        this.searchProfiles = [new PlanSearchProfile(options)];
    }

    searchName = "Select Plan(s)";
    renderOptions = { ui5ResourceId: "PlanSearchProfile" };
    searchProfileIdDefault = "default";
    searchProfiles: ISearchProfile[] = [];
    autoSearch = true;
}
